import { useMemo } from "react";
import {
  useUnpaidContractPayments,
  type UnpaidContractPaymentRow,
} from "@/partner/entities/billing";
import {
  summarizeUnpaidInvoices,
  type UnpaidInvoicesSummary,
} from "./unpaidInvoices";

/** null, пока нечего показывать: нет права, идёт загрузка или всё оплачено. */
export function useUnpaidInvoicesSummary(): UnpaidInvoicesSummary<UnpaidContractPaymentRow> | null {
  const { rows, count } = useUnpaidContractPayments();
  return useMemo(() => summarizeUnpaidInvoices(rows, count), [rows, count]);
}
